import { ErrorFill16, SuccessFill16, WarningFill16, InfoFill16 } from 'ui/icons/aurora';
import { BannerVariants } from './types';

export const BANNER_VARIANT_ICONS = {
  [BannerVariants.ERROR]: <ErrorFill16 data-test="icon-negativefill" />,
  [BannerVariants.INFO]: <InfoFill16 data-test="icon-infofill" />,
  [BannerVariants.NEUTRAL]: <InfoFill16 data-test="icon-infofill" />,
  [BannerVariants.SUCCESS]: <SuccessFill16 data-test="icon-positivefill" />,
  [BannerVariants.WARNING]: <WarningFill16 data-test="icon-warningfill" />,
};
